<template>
  <div>
    <div class="px-5">
      <div class="text-h4 font-weight-black">Privacy Policy</div>
      <div style="font-size: 10px">Last updated: April 15, 2021</div>
      <div class="mt-5">
        <p style="font-size: 12px">
          This Privacy Policy describes Our policies and procedures on the
          collection, use and disclosure of Your information when You use the
          Service and tells You about Your privacy rights and how the law
          protects You.
        </p>
        <p style="font-size: 12px">
          We use Your Personal data to provide and improve the Service. By using
          the Service, You agree to the collection and use of information in
          accordance with this Privacy Policy. This Privacy Policy has been
          created with the help of the Privacy Policy Generator.
        </p>
      </div>
    </div>
    <div class="px-5 mb-5">
      <v-expansion-panels>
        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Interpretation and Definitions
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            <p class="font-weight-black">Interpretation</p>
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
            <p class="font-weight-black mt-5">Definitions</p>
            For the purposes of this Privacy Policy:
            <ul>
              <li>
                Account means a unique account created for You to access our
                Service or parts of our Service.
              </li>
              <li>
                Affiliate means an entity that controls, is controlled by or is
                under common control with a party, where "control" means
                ownership of 50% or more of the shares, equity interest or other
                securities entitled to vote for election of directors or other
                managing authority.
              </li>
              <li>
                Application means the software program provided by the Company
                downloaded by You on any electronic device, named Teman Bakat
              </li>
              <li>
                Company (referred to as either "the Company", "We", "Us" or
                "Our" in this Agreement) refers to PT Hara Anargya, Jalan PH.H.
                Mustofa, Surapati Core Blok C 22, Pasirlayung, Kec. Cibeunying
                Kidul, Kota Bandung, Jawa Barat 40192.
              </li>
              <li>Country refers to: Indonesia</li>
              <li>
                Device means any device that can access the Service such as a
                computer, a cellphone or a digital tablet.
              </li>
              <li>
                Personal Data is any information that relates to an identified
                or identifiable individual.
              </li>
              <li>Service refers to the Application.</li>
              <li>
                Service Provider means any natural or legal person who processes
                the data on behalf of the Company. It refers to third-party
                companies or individuals employed by the Company to facilitate
                the Service, to provide the Service on behalf of the Company, to
                perform services related to the Service or to assist the Company
                in analyzing how the Service is used.
              </li>
              <li>
                Third-party Social Media Service refers to any website or any
                social network website through which a User can log in or create
                an account to use the Service.
              </li>
              <li>
                Usage Data refers to data collected automatically, either
                generated by the use of the Service or from the Service
                infrastructure itself (for example, the duration of a page
                visit).
              </li>
              <li>
                You means the individual accessing or using the Service, or the
                company, or other legal entity on behalf of which such
                individual is accessing or using the Service, as applicable.
              </li>
            </ul>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Collecting and Using Your Personal Data
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            <div class="text-h6 font-weight-bold">Types of Data Collected</div>
            <p class="font-weight-black">Personal Data</p>
            While using Our Service, We may ask You to provide Us with certain
            personally identifiable information that can be used to contact or
            identify You. Personally identifiable information may include, but
            is not limited to:
            <ul>
              <li>Email address</li>
              <li>First name and last name</li>
              <li>Phone number</li>
              <li>Usage Data</li>
            </ul>
            <br />
            <p class="font-weight-black">Usage Data</p>
            Usage Data is collected automatically when using the Service. Usage
            Data may include information such as Your Device's Internet Protocol
            address (e.g. IP address), browser type, browser version, the pages
            of our Service that You visit, the time and date of Your visit, the
            time spent on those pages, unique device identifiers and other
            diagnostic data. When You access the Service by or through a mobile
            device, We may collect certain information automatically, including,
            but not limited to, the type of mobile device You use, Your mobile
            device unique ID, the IP address of Your mobile device, Your mobile
            operating system, the type of mobile Internet browser You use,
            unique device identifiers and other diagnostic data. We may also
            collect information that Your browser sends whenever You visit our
            Service or when You access the Service by or through a mobile
            device. <br /><br />
            <p class="font-weight-black">
              Information Collected while Using the Application
            </p>
            While using Our Application, in order to provide features of Our
            Application, We may collect, with Your prior permission:
            <ul>
              <li>
                Pictures and other information from your Device's camera and
                photo library We use this information to provide features of Our
                Service, to improve and customize Our Service. The information
                may be uploaded to the Company's servers and/or a Service
                Provider's server or it may be simply stored on Your device.
              </li>
            </ul>
            You can enable or disable access to this information at any time,
            through Your Device settings.
            <div class="text-h6 font-weight-bold">Types of Data Collected</div>
            The Company may use Personal Data for the following purposes:
            <ul>
              <li>
                To provide and maintain our Service, including to monitor the
                usage of our Service.
              </li>
              <li>
                To manage Your Account: to manage Your registration as a user of
                the Service. The Personal Data You provide can give You access
                to different functionalities of the Service that are available
                to You as a registered user.
              </li>
              <li>
                For the performance of a contract: the development, compliance
                and undertaking of the purchase contract for the products, items
                or services You have purchased or of any other contract with Us
                through the Service.
              </li>
              <li>
                To contact You: To contact You by email, telephone calls, SMS,
                or other equivalent forms of electronic communication, such as a
                mobile application's push notifications regarding updates or
                informative communications related to the functionalities,
                products or contracted services, including the security updates,
                when necessary or reasonable for their implementation.
              </li>
              <li>
                To provide You with news, special offers and general information
                about other goods, services and events which we offer that are
                similar to those that you have already purchased or enquired
                about unless You have opted not to receive such information.
              </li>
              <li>
                To manage Your requests: To attend and manage Your requests to
                Us.
              </li>
              <li>
                For business transfers: We may use Your information to evaluate
                or conduct a merger, divestiture, restructuring, reorganization,
                dissolution, or other sale or transfer of some or all of Our
                assets, whether as a going concern or as part of bankruptcy,
                liquidation, or similar proceeding, in which Personal Data held
                by Us about our Service users is among the assets transferred.
              </li>
              <li>
                For other purposes: We may use Your information for other
                purposes, such as data analysis, identifying usage trends,
                determining the effectiveness of our promotional campaigns and
                to evaluate and improve our Service, products, services,
                marketing and your experience. We may share Your personal
                information in the following situations:
                <ul>
                  <li>
                    With Service Providers: We may share Your personal
                    information with Service Providers to monitor and analyze
                    the use of our Service, to contact You.
                  </li>
                  <li>
                    For business transfers: We may share or transfer Your
                    personal information in connection with, or during
                    negotiations of, any merger, sale of Company assets,
                    financing, or acquisition of all or a portion of Our
                    business to another company.
                  </li>
                  <li>
                    With Affiliates: We may share Your information with Our
                    affiliates, in which case we will require those affiliates
                    to honor this Privacy Policy. Affiliates include Our parent
                    company and any other subsidiaries, joint venture partners
                    or other companies that We control or that are under common
                    control with Us.
                  </li>
                  <li>
                    With business partners: We may share Your information with
                    Our business partners to offer You certain products,
                    services or promotions.
                  </li>
                  <li>
                    With other users: when You share personal information or
                    otherwise interact in the public areas with other users,
                    such information may be viewed by all users and may be
                    publicly distributed outside. If You interact with other
                    users or register through a Third-Party Social Media
                    Service, Your contacts on the Third-Party Social Media
                    Service may see Your name, profile, pictures and description
                    of Your activity. Similarly, other users will be able to
                    view descriptions of Your activity, communicate with You and
                    view Your profile.
                  </li>
                  <li>
                    With Your consent: We may disclose Your personal information
                    for any other purpose with Your consent.
                  </li>
                </ul>
              </li>
            </ul>
            <br />
            <div class="text-h6 font-weight-bold">
              Retention of Your Personal Data
            </div>
            The Company will retain Your Personal Data only for as long as is
            necessary for the purposes set out in this Privacy Policy. We will
            retain and use Your Personal Data to the extent necessary to comply
            with our legal obligations (for example, if we are required to
            retain your data to comply with applicable laws), resolve disputes,
            and enforce our legal agreements and policies. The Company will also
            retain Usage Data for internal analysis purposes. Usage Data is
            generally retained for a shorter period of time, except when this
            data is used to strengthen the security or to improve the
            functionality of Our Service, or We are legally obligated to retain
            this data for longer time periods.
            <div class="text-h6 font-weight-bold">
              Transfer of Your Personal Data
            </div>
            Your information, including Personal Data, is processed at the
            Company's operating offices and in any other places where the
            parties involved in the processing are located. It means that this
            information may be transferred to — and maintained on — computers
            located outside of Your state, province, country or other
            governmental jurisdiction where the data protection laws may differ
            than those from Your jurisdiction. Your consent to this Privacy
            Policy followed by Your submission of such information represents
            Your agreement to that transfer. The Company will take all steps
            reasonably necessary to ensure that Your data is treated securely
            and in accordance with this Privacy Policy and no transfer of Your
            Personal Data will take place to an organization or a country unless
            there are adequate controls in place including the security of Your
            data and other personal information.
            <div class="text-h6 font-weight-bold">
              Disclosure of Your Personal Data
            </div>
            <br />
            <p class="font-weight-black">Business Transactions</p>
            If the Company is involved in a merger, acquisition or asset sale,
            Your Personal Data may be transferred. We will provide notice before
            Your Personal Data is transferred and becomes subject to a different
            Privacy Policy.
            <br /><br />
            <p class="font-weight-black">Law enforcement</p>
            Under certain circumstances, the Company may be required to disclose
            Your Personal Data if required to do so by law or in response to
            valid requests by public authorities (e.g. a court or a government
            agency).
            <br /><br />
            <p class="font-weight-black">Other legal requirements</p>
            The Company may disclose Your Personal Data in the good faith belief
            that such action is necessary to:
            <ul>
              <li>Comply with a legal obligation</li>
              <li>Protect and defend the rights or property of the Company</li>
              <li>
                Prevent or investigate possible wrongdoing in connection with
                the Service
              </li>
              <li>
                Protect the personal safety of Users of the Service or the
                public
              </li>
              <li>Protect against legal liability</li>
            </ul>
            <br />
            <div class="text-h6 font-weight-bold">
              Retention of Your Personal Data
            </div>
            The security of Your Personal Data is important to Us, but remember
            that no method of transmission over the Internet, or method of
            electronic storage is 100% secure. While We strive to use
            commercially acceptable means to protect Your Personal Data, We
            cannot guarantee its absolute security.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Collecting and Using Your Assessment Data
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            <div class="text-h6 font-weight-bold">
              1. Information Collected About You
            </div>
            <br />
            Whenever you complete a quiz, test, or assessment (collectively,
            "assessment") on Teman Bakat Apps ("the mobile apps"), all of your
            responses to the questions ("your data") are collected and stored in
            a password-protected database. You may choose to create a Teman
            Bakat Apps User Account ("account"). When you create an account,
            your name and email address ("account information") are collected.
            If you complete an assessment while signed into your account, your
            data will be linked to your account information in the app's
            password protected database. The app also records your Internet
            Protocol address (IP).
            <br /><br />
            <div class="text-h6 font-weight-bold">
              2. How Your Data is Used / Processed
            </div>
            <br />
            <div class="text-h8 font-weight-bold">a. Your Data</div>
            <br />
            Some assessments on the app are provided purely for entertainment
            and used in current scientific research. Whenever you complete an
            assessment on the app, your data are collected and stored
            indefinitely in a password-protected database. For some assessments,
            your data may be analyzed for scientific research purposes. What
            this means is that your individual data will be averaged together
            with data from many other people, and psychological researchers will
            look for trends in the aggregate data. Scientific researchers are
            not interested in building a profile of you, personally. Rather,
            they are interested in understanding general principles about how
            people function. The aggregate data can be published in journals,
            presented at conferences, or used in other academic contexts.
            <br /><br />
            The scientific researchers who operate Teman Bakat App strongly
            support open science. This means that your individual data may be
            stripped of any personally-identifying information and uploaded to
            scientific data repositories where other scientists can access the
            data to verify and replicate findings that are published in
            journals. Importantly, when your individual data are uploaded to
            scientific data repositories, they are completely anonymous and
            cannot be linked to you personally in any way, shape, or form. This
            means that your name, email address, birthday, account information,
            IP address, and any text typed into free response fields in
            assessments will NEVER be posted to scientific data repositories or
            shared with non-academic third parties in any way. Your completely
            anonymous answers to the questionnaires, however, may be posted to
            scientific data repositories.
            <br /><br />
            Any personal information that could be used to identify you (e.g.,
            name, account details, email address, birthday, text typed into
            free-response fields in assessments) is always kept completely
            private. It is never shared with non-academic third parties, and it
            is never used for commercial purposes. Your confidentiality will be
            protected to the maximum extent allowable by law.
            <br /><br />
            <div class="text-h8 font-weight-bold">
              b. Your Account Information
            </div>
            <br />
            Your account information is used only for (a) authentication
            purposes (i.e., to allow you to log into your account), and (b) to
            allow you to share your the results of your assessments with
            friends, if desired (see Section 6 below). Your account information
            and IP address are never shared with non-academic third parties and
            are never used for commercial purposes. Your IP address is used
            primarily to help the website identify duplicate responses on the
            assessments. Information about which internet browser you use is
            used primarily to help with troubleshooting any bugs/issues should
            you contact our technical support.
            <br /><br />
            <div class="text-h6 font-weight-bold">
              3. Giving Consent to Have Your Responses Collected and Analyzed
            </div>
            <br />
            Before completing an assessment on the website, you will be provided
            with a consent page. The consent page will inform you that your data
            will be collected for scientific research purposes. In order to
            begin an assessment, you must check a box or click a button to
            indicate that you explicitly consent to allow your data to be
            collected, analyzed for scientific research purposes, and posted in
            anonymized form to scientific data repositories as described in
            Section 2a above.
            <br /><br />
            However, when completing assessments, you may choose to skip any
            questions that you do not wish to answer and/or for which you do not
            wish to have your responses collected and analyzed for scientific
            research purposes. Any questions that you voluntarily choose to
            answer will be collected and analyzed for scientific research
            purposes as described in Section 2a above
            <br /><br />
            <div class="text-h6 font-weight-bold">4. Results Pages</div>
            <br />
            When you complete an assessment on the mobile apps, you will be
            provided with a results page that summarizes some of your data. When
            you complete the assessment on the mobile apps, you will be
            presented with a results page that summarizes some of your data.
            This results page will be saved in your account. The results page
            contains your personal information, and your test results
            <br /><br />
            <div class="text-h6 font-weight-bold">5. User Accounts</div>
            <br />
            You may choose to create an account. When you create an account, you
            can supply basic account information including your name and email
            address. As described in Section 2b above, your account information
            is never shared with non-academic third parties and it is never used
            for commercial purposes. Your email address may be used to send you
            promotional material from the app or to send you reminders to
            complete multi-part assessments that you have started.
            <br /><br />
            As outlined in Section 1 above, when you complete an assessment
            while logged into your account, your data will be saved to your
            account. This means that your account information is linked to your
            data in the app's password-protected database. This is primarily for
            your benefit, so that you may review the results of past
            assessments. When scientific researchers analyze your data for
            scientific purposes (see Section 2a above), your account information
            is not linked to your data. This means that the scientists analyzing
            your data do not see your name, email address, or other account
            information.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Children’s Privacy
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Our Service does not address anyone under the age of 13. We do not
            knowingly collect personally identifiable information from anyone
            under the age of 13. If You are a parent or guardian and You are
            aware that Your child has provided Us with Personal Data, please
            contact Us. If We become aware that We have collected Personal Data
            from anyone under the age of 13 without verification of parental
            consent, We take steps to remove that information from Our servers.
            If We need to rely on consent as a legal basis for processing Your
            information and Your country requires consent from a parent, We may
            require Your parent's consent before We collect and use that
            information.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Link to Other Websites
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            Our Service may contain links to other websites that are not
            operated by Us. If You click on a third party link, You will be
            directed to that third party's site. We strongly advise You to
            review the Privacy Policy of every site You visit. We have no
            control over and assume no responsibility for the content, privacy
            policies or practices of any third party sites or services.
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel class="panel-accordion mt-5">
          <v-expansion-panel-header class="panel-accordion font-weight-black">
            Contact Us
          </v-expansion-panel-header>
          <v-expansion-panel-content class="py-5" style="font-size: 12px">
            If you have any questions about this Privacy Policy, You can contact
            us:
            <ul>
              <li>By phone number: +62 877-1449-1482</li>
              <li>By mail: hara@anargya.id</li>
            </ul>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>
<script>
export default {
  name: "PrivacyPolicy",
};
</script>
<style scoped>
.panel-accordion {
  background-color: #e5e5e5;
}
</style>
